module.exports = __webpack_public_path__ + "img/reward-box02-pc.6c137361.png";